import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button, Modal, Divider } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { has } from 'lodash';
import { push } from 'react-router-redux';
import styled from 'styled-components';

import { HHEncrypt } from '../common/util';
// import { HHInput } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import { userLogout, updatePassword } from '../actions';
import { Input } from '../../uiStandard/event/input';
import { FormSubmitButton } from '../../uiStandard/event/formInput';import { OrginalButton, Button as CustomButton } from '../../uiStandard/event/button';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) => Yup.object().shape({
    oldPassword: Yup.string()
      .max(32, translate('form.error.string.max'))
      .required(translate('form.error.mixed.required')),
    newPassword: Yup.string()
      .min(8, translate('form.error.string.min'))
      .max(32, translate('form.error.string.max'))
      .required(translate('form.error.mixed.required')),
    confirmPassword: Yup.string()
      .min(8, translate('form.error.string.min'))
      .max(32, translate('form.error.string.max'))
      // eslint-disable-next-line func-names
      .test('matchPasswords', translate('form.error.mixed.matchPasswords'), function (value) {
        const { newPassword } = this.parent;
        return newPassword === value;
      })
  }),
  mapPropsToValues: () => ({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  }),
  handleSubmit: ({ oldPassword, newPassword }, { props, setSubmitting }) => {
    const { user, callback } = props;

    const { email, id, username } = has(user, 'profile.basicInfo') ? user.profile.basicInfo : {};

    const { token } = user;

    if (!(email && id && username && token)) {
      props.userLogout().then(props.push('/'));
    }

    const requestBody = {
      token,
      id,
      email,
      username,
      oldPassword: HHEncrypt(oldPassword),
      newPassword: HHEncrypt(newPassword)
    };
    props.updatePassword(requestBody)
      .then((res) => {
        if (res.code === 200 && callback) { callback(); }
        setSubmitting(false);
      });
  },
  displayName: FORM_NAME.NEW_PASSWORD_FORM
});

const UpdatePasswordForm = ({
  handleSubmit, isSubmitting, translate, exportAccount, isExportAccount, toggleModal, modalOpen, deleteAccount
}) => (
  <React.Fragment>
    <Form className='editProject' onSubmit={handleSubmit}>
      <Form.Field>
        {/* <label htmlFor='oldPassword'>
          {translate('old.password.required')}
        </label> */}
        <Field
          name='oldPassword'
          // component={HHInput}
          component={Input}
          otherProps={{
            id: 'oldPassword',
            type: 'password',
            maxLength: 32,
            label: translate('old.password.required')
          }}
        />
      </Form.Field>

      <Form.Field>
        {/* <label htmlFor='newPassword'>
          {translate('new.password.required')}
        </label> */}
        <Field
          name='newPassword'
          // component={HHInput}
          component={Input}
          otherProps={{
            id: 'newPassword',
            type: 'password',
            maxLength: 32,
            label: translate('new.password.required')
          }}
        />
      </Form.Field>

      <Form.Field>
        {/* <label htmlFor='newPassword'>
          {translate('new.password.confirm.required')}
        </label> */}
        <Field
          name='confirmPassword'
          // component={HHInput}
          component={Input}
          otherProps={{
            id: 'confirmPassword',
            type: 'password',
            maxLength: 32,
            label: translate('new.password.confirm.required')
          }}
        />
      </Form.Field>

      <Modal.Actions>
        {/* <Button
          primary
          size='large'
          type='submit'
          disabled={isSubmitting}
          loading={isSubmitting}
          className='g-rounded'
        >
          {translate('update.password')}
        </Button> */}
        <RegularButton
          label={translate('update.password')} disabled={isSubmitting}
          isSubmitting={isSubmitting} type='button'
        />
      </Modal.Actions>

    </Form>
    <Divider />
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      {/* <Button
        primary
        disabled={isExportAccount}
        size='large' className='g-rounded' onClick={exportAccount}
      >{isExportAccount ? 'Pending' : 'Export Data'}
      </Button> */}
      <CustomButton
        isPrimary isSmall label={isExportAccount ? 'Pending' : 'Export Data'}
        onClick={exportAccount}
      />
      <Modal
        centered={false}
        open={modalOpen}
        size='tiny'
        trigger={
          // <Button
          //   color='red'
          //   content={translate('deleteAccount')}
          //   size='large'
          //   onClick={toggleModal}
          //   className='g-rounded'
          // />
          <StyledButton
            // color='red'
            // content={translate('deleteAccount')}
            // size='large'
            isSmall
            onClick={toggleModal}
          >{translate('deleteAccount')}
          </StyledButton>
        }
      >
        <Modal.Header>{translate('deleteAccount')}</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {translate('deleteAccountInfo')}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={toggleModal} primary className='g-rounded'>
            {translate('button.cancel')}
          </Button>
          <Button negative onClick={deleteAccount} className='g-rounded'>
            {translate('deleteAccount')}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  </React.Fragment>
);

const RegularButton = styled(FormSubmitButton)`
&&&&& {
  min-height: 41.13px;
  width: 338px;
  margin: 0 auto;
  @media (max-width: 768px) {
    width: 100%;
  }
}
`;

const StyledButton = styled(OrginalButton)`
background: #ea3a3d;
`;

export default compose(
  withLocalize,
  withRouter,
  connect(
    ({ user }) => ({ user }),
    { userLogout, updatePassword, push }
  ),
  formikEnhancer
)(UpdatePasswordForm);



// WEBPACK FOOTER //
// ./src/components/forms/updatePasswordForm.js